import type { FC } from 'react';

import SettingsForm from '../components/SettingsForm';
import { useSettingsPage } from '../hooks/useSettingsPage.hook';

const SettingsPage: FC = () => {
  const {
    form,
    errors,
    isLoading,
    isSaving,
    isUploadingQr,
    uploadError,
    submitError,
    successMessage,
    onChange,
    onUploadQrImage,
    onClearQrImage,
    onSubmit,
  } = useSettingsPage();

  return (
    <div className="flex flex-col gap-4 p-4 md:p-6">
      <div>
        <h1 className="text-[20px] font-bold text-[var(--color-ink)]">Settings</h1>
        <p className="text-[13px] text-[var(--color-ink-muted)]">
          Fee percentages and UPI payment details.
        </p>
      </div>

      {isLoading ? (
        <p className="p-8 text-center text-[13px] text-[var(--color-ink-muted)]">Loading…</p>
      ) : (
        <>
          <SettingsForm
            form={form}
            errors={errors}
            isUploadingQr={isUploadingQr}
            uploadError={uploadError}
            onChange={onChange}
            onUploadQrImage={onUploadQrImage}
            onClearQrImage={onClearQrImage}
          />

          <div className="flex items-center gap-3">
            <button
              type="button"
              onClick={onSubmit}
              disabled={isSaving}
              className="rounded-lg bg-brand-500 px-4 py-2.5 text-[13px] font-semibold text-white hover:bg-brand-600 disabled:opacity-50"
            >
              {isSaving ? 'Saving…' : 'Save changes'}
            </button>
            {successMessage ? (
              <span className="text-[13px] font-semibold text-emerald-600">{successMessage}</span>
            ) : null}
            {submitError ? <span className="text-[13px] text-red-600">{submitError}</span> : null}
          </div>
        </>
      )}
    </div>
  );
};

export default SettingsPage;
